import React from 'react';
import 'antd/dist/antd.css';
import './App.css';
import { Layout, Button, Tooltip } from 'antd';
import Dashboard from './components/Dashboard';
import Checkout from './components/Checkout';
import ModalAge from './components/ModalAge';
import UnderAge from './components/UnderAge.js';
import { HeartFilled } from '@ant-design/icons';
import { CookiesProvider } from 'react-cookie';
import ModalRules from './components/ModalRules';
import { MailOutlined, AimOutlined, HomeOutlined } from '@ant-design/icons';
import { Router, Link } from "@reach/router"


const { Header, Content, Footer, Sider } = Layout;


class App extends React.Component {

  render() {

    return (
      <div className="app">
        <CookiesProvider >
          <ModalAge initShowModal={true} />
          <Router>
            <AppContent path="/">
              <Dashboard path="/" />
              <Checkout path="/thankyou" />
              <UnderAge path="/underage" />
            </AppContent>
          </Router>

        </CookiesProvider>

      </div>
    );
  }
}


const AppContent = (props) => {

  const copyrightDate = (new Date()).getFullYear();
  return (
    <>

      <Layout style={{ minHeight: '100vh' }}>
        {/* Sidebar */}
        <Sider className="sidebar" breakpoint="lg" collapsedWidth="0">
          <div className="sidebar__logo">
            <Link to="/">
              <span className="sidebar__logo-highlighted" style={{ color: 'white' }}>Břevnovský eshop</span>
              <img style={{ paddingTop: 15 }} src={process.env.PUBLIC_URL + '/resized_images/znak_brevnovsky_pivovar_negativ_preview_rev_1.png'} />
            </Link>
          </div>
          <div className="sidebar__text">
            <ModalRules />
          </div>

          <div className="sidebar__text">
            <strong>Otvírací doba prodejny</strong>
          </div>
          <div className="sidebar__small_text">
            <table>
              <tbody>
                <tr>
                  <td className="sidebar__td">Po: 10:00 - 17:00</td>
                </tr>
                <tr>
                  <td className="sidebar__td">Út: 10:00 - 17:00</td>
                </tr>
                <tr>
                  <td className="sidebar__td">St: 10:00 - 17:00</td>
                </tr>
                <tr>
                  <td className="sidebar__td">Čt: 10:00 - 19:00</td>
                </tr>
                <tr>
                  <td className="sidebar__td">Pá: 10:00 - 17:00</td>
                </tr>
                <tr></tr>
                <tr>
                  <td className="sidebar__td" style={{ textAlign: 'center', marginBottom: '50px', fontSize: 16 }}> <strong>Polední pauza:</strong></td>
                </tr>
                <tr>
                  <td className="sidebar__td" style={{ textAlign: 'center' }}>11:45 - 12:30</td>
                </tr>
                <tr></tr>
                <tr>
                  <td className="sidebar__td" style={{ textAlign: 'center', marginBottom: '50px', fontSize: 16 }}> <strong>Kontakty:</strong></td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontSize: 16 }}>728 683 558</td>
                </tr>
                <tr>
                  {/* <td style={{textAlign:'center',fontSize:16}}><a href="mailto:objednavky@brevnovskypivovar.cz?subject=Objednávka z eshopu"><Button type="primary" shape="round" icon={<MailOutlined />}>Email</Button></a></td> */}
                  <td style={{ textAlign: 'center', fontSize: 16 }}><Tooltip title="objednavky@brevnovskypivovar.cz" ><Button type="primary" shape="round" disabled={true} icon={<MailOutlined />}>Email</Button></Tooltip></td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontSize: 16 }}><a href="https://g.page/Brevnovskypivovar?share" target="_blank"><Button type="primary" shape="round" icon={<AimOutlined />}>Mapa</Button></a></td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontSize: 16 }}><a href="http://www.brevnovskypivovar.cz/" target="_blank"><Button type="primary" shape="round" icon={<HomeOutlined />}>Web pivovaru</Button></a></td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontSize: 16 }}><a href="https://www.pivo-klub.cz/" target="_blank"><Button type="primary" shape="round" icon={<HomeOutlined />}>Pivovarský klub</Button></a></td>
                </tr>
                <tr>
                  <td style={{ textAlign: 'center', fontSize: 16 }}><a href="https://www.pivo-dum.cz/" target="_blank"><Button type="primary" shape="round" icon={<HomeOutlined />}>Pivovarský dům</Button></a></td>
                </tr>
              </tbody>
            </table>
          </div>

        </Sider>
        <Layout>
          {/* Header */}
          {/* <Header className="header">
          <div className="ant-card-meta-title" >Super nabidka</div>
        </Header> */}

          {/* Content */}
          <Content style={{ margin: '24px 16px 0' }}>
            <div style={{ padding: '0 24px 24px', background: '#fff', height: '100%' }}>
              {props.children}
            </div>
          </Content>

          {/* Footer */}
          <Footer style={{ textAlign: 'center' }}>

            <span> S <HeartFilled style={{ color: '#e30613' }} /> vytvořila firma <a href="https://soulution.cz/" target="_blank">Soulution</a> ©{copyrightDate}</span>
          </Footer>
        </Layout>
      </Layout>
    </>
  );

}

export default App;
